<template>
  <div class="product">
    <banner3 title="产品中心" />
    <div class="product-section" v-loading="loading">
      <div class="product-section-content">
        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-list-more">
              <router-link
                      class="span-text"
                      :to="{ name: item.Type}"
              >
                <img :src="getImageUrl(item.img)"/>
                <p class="item-list-title">{{item.Title}}</p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import itemImg1 from '../assets/img/lamp/lamp_bh.png';
  import itemImg2 from '../assets/img/lamp/lamp_xd.png';
  import itemImg3 from '../assets/img/lamp/lamp_fp.png';
  import itemImg4 from '../assets/img/lamp/lamp_seedling.png';
  import itemImg5 from '../assets/img/lamp/lamp_city.png';
  import itemImg6 from '../assets/img/lamp/lamp_fungus.png';
  import Banner3 from "../components/Banner3";
  export default {
    name: "product",
    components: {
      Banner3
    },
    data() {
      return {
        loading: true,
        newsList:  [
          {Id: 1, Title: "冰火系列",Type: "productDetailsBH",img:'lamp_bh'},
          {Id: 2, Title: "炫碟系列",Type: "productDetailsXD",img:'lamp_xd'},
          {Id: 3, Title: "飞瀑系列",Type: "productDetailsFP",img:'lamp_fp'},
          {Id: 4, Title: "种苗系列",Type: "productDetailsZM",img:'lamp_seedling'},
          {Id: 5, Title: "城市阳台系列",Type: "productDetailsCS",img:'lamp_city'},
          {Id: 6, Title: "菌菇工厂系列",Type: "productDetailsJG",img:'lamp_fungus'}
        ],
        newstype: 1
      };
    },
    methods: {
     getImageUrl(img) {
            switch (img) {
                case 'lamp_bh':
                    return itemImg1;
                case 'lamp_xd':
                    return itemImg2;
                case 'lamp_fp':
                    return itemImg3;
                case 'lamp_seedling':
                    return itemImg4;
                case 'lamp_city':
                    return itemImg5;
                case 'lamp_fungus':
                    return itemImg6;
                // 返回其他图片...
                default:
                    return ''; // 默认图片路径
            }
       this.loading = false;
        },
      loadData() {
        this.loading = false;
        // this.$http
        //         .get(`News?type=${this.newstype}&num=6`)
        //         .then(response => {
        //           //console.log(response);
        //           this.newsList = [
        //             {Id: 1, Title: "冰火系列",Type: 1,img:'冰火系列'},
        //             {Id: 2, Title: "混光催花灯",Type: 1,img:'混光催花灯'},
        //             {Id: 3, Title: "飞瀑系列",Type: 1,img:'飞瀑系列'},
        //             {Id: 4, Title: "种苗系列",Type: 1,img:'种苗系列'},
        //             // {Id: 5, Title: "城市阳台系列",Type: 1,img:'城市阳台系列'},
        //             {Id: 6, Title: "菌菇工厂系列",Type: 1,img:'菌菇工厂系列'}
        //             ];
        //           this.loading = false;
        //           //window.console.log(this.newsList);
        //         })
        //         .catch(function(error) {
        //           window.console.log(error);
        //         });
      }
    },
    mounted() {
      this.loadData();
    },
    watch: {
      newstype(type) {
        window.console.log(type);
        this.loadData();
      }
    }
  };
</script>

<style lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .product {
    width: 100%;
    height: 100%;
    background-color: #14679f;
    position: relative;
    overflow: hidden;

    &-section {
      width: 100%;
      //height: 1600px;

      &-content {
        width: 100%;
        //height: 1600px;
        margin: 0 auto;
        background-color: #fff;
        /*border: 1px solid red;*/

        .content-nav {
          width: 800px;
          height: 55px;
          margin: 0 auto;
          display: flex;
          //justify-content: center;
          align-items: center;
          position: relative;
          bottom: 60px;
          /*border: 1px solid red;*/

          &-btn {
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #e4e4e4;
            transition: all 0.2s;
          }

          .content-nav-active {
            background-color: red;
            color: #fff;
          }
        }

        .content-nav-item {
          height: 800px;
          width: 100%;
          margin: 0 auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          //border: 1px solid blue;

          .item-list {
            background-color: rgb(244,243,241);
            width: 25%;
            height: 250px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 50px;
            margin-left: auto;
            /*border: 1px solid rgba(72, 171, 239, 0.4);*/
            .img1 {
              width: 100%;
              height: 250px;
            }
            &:hover {
              border: 1px solid #fff;
              box-shadow: 0 0 5px 2px #bfd3e0;
            }
            .item-img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
              background-origin: content-box;
            }

            &-title {
              line-height:50px;
              text-align:center;
              text-indent: 10px;
              font-family: 'Chomsky', sans-serif;
              font-weight: bold; /* 设置字体粗细 */
              position: absolute;
              width: 24.9%;
              height: 50px;
              color: rgba(127, 123, 117);
              font-size: 16px;
              letter-spacing: 0.5px;
              /*padding: 0 10px;*/
              overflow: hidden;
              text-overflow: ellipsis;
              /*margin-top: 25px;*/
              border: 1px solid rgba(178, 174, 187, 0.3);
              /*background-color: rgba(55, 162, 236, 0.2);*/
            }

            &-content {
              width: 273px;
              height: 100px;
              font-size: 14px;
              color: gray;

              // 文本长度处理 begin
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;
              white-space: normal !important;
              word-wrap: break-word;
              // 文本长度处理 ending
            }

            &-more {
              width: 100%;
              /*height: 30%;*/
              /*padding-top: 0px;*/
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
          }
        }
      }
    }
    .span-text {
      /*text-decoration: none;*/
      img {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-origin: content-box;
        width: 100%;
        height: 100%
      }
    }
  }
</style>
